(function () {
  'use strict';

  function boxStatus(count, target) {
    target = target || 12;
    var remaining = Math.max(0, target - count);
    var over = Math.max(0, count - target);
    var complete = count === target;
    var message;
    if (over > 0) {
      message = 'Remove ' + over;
    } else if (remaining > 0) {
      message = 'Add ' + remaining + ' more';
    } else {
      message = 'Box ready — add to cart';
    }
    return { complete: complete, remaining: remaining, over: over, canSubmit: complete, message: message };
  }

  function boxTotals(lines, discountPercentage) {
    var subtotalCents = 0;
    for (var i = 0; i < lines.length; i++) {
      subtotalCents += lines[i].priceCents * lines[i].quantity;
    }
    var discountCents = Math.round(subtotalCents * (discountPercentage / 100));
    return { subtotalCents: subtotalCents, discountCents: discountCents, totalCents: subtotalCents - discountCents };
  }

  function buildCartItems(selections, boxLabel) {
    var items = [];
    for (var i = 0; i < selections.length; i++) {
      var sel = selections[i];
      if (sel.quantity > 0) {
        items.push({ id: sel.variantId, quantity: sel.quantity, properties: { _lb_box: boxLabel } });
      }
    }
    return items;
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal = (typeof decimal === 'undefined') ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? (decimal + parts[1]) : '';
      return dollars + rest;
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/g, value);
  }

  if (typeof customElements !== 'undefined' && typeof HTMLElement !== 'undefined') {
    class LbBoxBuilder extends HTMLElement {
      connectedCallback() {
        this.target = parseInt(this.dataset.target, 10) || 12;
        this.discount = parseFloat(this.dataset.discount) || 0;
        this.boxLabel = this.dataset.boxLabel || 'LiteBite Box';
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('.lb-box-tile'));
        this.slots = Array.prototype.slice.call(this.querySelectorAll('[data-slot]'));
        this.submitBtn = this.querySelector('[data-box-submit]');
        this.countMobile = this.querySelector('[data-box-count-mobile]');
        this.submitMobile = this.querySelector('[data-box-submit-mobile]');
        this.errorEl = this.querySelector('[data-box-error]');
        this.state = {};

        this.addEventListener('click', this.onClick.bind(this));
        if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
        if (this.submitMobile) this.submitMobile.addEventListener('click', this.onSubmit.bind(this));
        this.render();
      }

      onClick(evt) {
        if (this.submitting) return;
        var btn = evt.target.closest('[data-action]');
        if (!btn) return;
        var tile = btn.closest('.lb-box-tile');
        if (!tile) return;
        var id = tile.dataset.variantId;
        var current = this.state[id] ? this.state[id].quantity : 0;
        var count = this.count();
        if (btn.dataset.action === 'increase') {
          if (count >= this.target) return;
          this.state[id] = { variantId: parseInt(id, 10), quantity: current + 1, priceCents: parseInt(tile.dataset.price, 10) };
        } else if (btn.dataset.action === 'decrease') {
          if (current === 0) return;
          this.state[id] = { variantId: parseInt(id, 10), quantity: current - 1, priceCents: parseInt(tile.dataset.price, 10) };
        } else {
          return;
        }
        this.render();
      }

      count() {
        var c = 0;
        for (var id in this.state) { if (this.state.hasOwnProperty(id)) c += this.state[id].quantity; }
        return c;
      }

      selections() {
        var out = [];
        for (var id in this.state) { if (this.state.hasOwnProperty(id)) out.push(this.state[id]); }
        return out;
      }

      render() {
        var count = this.count();
        var status = boxStatus(count, this.target);
        var lines = this.selections().map(function (s) { return { priceCents: s.priceCents, quantity: s.quantity }; });
        var totals = boxTotals(lines, this.discount);

        this.querySelector('[data-box-count]').textContent = count;
        this.querySelector('[data-box-message]').textContent = status.message;
        this.querySelector('[data-box-subtotal]').textContent = count ? formatMoney(totals.subtotalCents, this.moneyFormat) : '—';
        this.querySelector('[data-box-savings]').textContent = count ? '−' + formatMoney(totals.discountCents, this.moneyFormat) : '—';
        this.querySelector('[data-box-total]').textContent = count ? formatMoney(totals.totalCents, this.moneyFormat) : '—';

        this.fillSlots();

        this.submitBtn.disabled = !status.canSubmit;
        if (this.countMobile) this.countMobile.textContent = count;
        if (this.submitMobile) this.submitMobile.disabled = !status.canSubmit;
        this.syncTiles(count);
      }

      syncTiles(count) {
        var atCap = count >= this.target;
        for (var i = 0; i < this.tiles.length; i++) {
          var tile = this.tiles[i];
          var entry = this.state[tile.dataset.variantId];
          var qty = entry ? entry.quantity : 0;
          var qtyEl = tile.querySelector('[data-qty]');
          if (qtyEl) qtyEl.textContent = qty;
          tile.classList.toggle('is-selected', qty > 0);
          var inc = tile.querySelector('[data-action="increase"]');
          if (inc) inc.disabled = atCap;
        }
      }

      fillSlots() {
        // Flatten selections into an ordered list of units (tile order), each with its flavour image.
        var units = [];
        for (var i = 0; i < this.tiles.length; i++) {
          var tile = this.tiles[i];
          var entry = this.state[tile.dataset.variantId];
          var q = entry ? entry.quantity : 0;
          for (var k = 0; k < q; k++) {
            units.push({ img: tile.dataset.image || '', title: tile.dataset.title || '' });
          }
        }
        for (var s = 0; s < this.slots.length; s++) {
          var slot = this.slots[s];
          if (s < units.length) {
            var u = units[s];
            slot.classList.add('is-filled');
            if (u.img) {
              slot.classList.add('has-img');
              var img = slot.firstChild;
              if (!img || img.tagName !== 'IMG') {
                slot.textContent = '';
                img = document.createElement('img');
                slot.appendChild(img);
              }
              if (img.getAttribute('src') !== u.img) img.setAttribute('src', u.img);
              img.setAttribute('alt', u.title);
            } else {
              slot.classList.remove('has-img');
              slot.textContent = '';
            }
          } else {
            slot.classList.remove('is-filled');
            slot.classList.remove('has-img');
            slot.textContent = '';
          }
        }
      }

      onSubmit() {
        if (this.submitting || this.count() !== this.target) return;
        this.submitting = true;
        var items = buildCartItems(this.selections(), this.boxLabel);
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Adding…';
        if (this.submitMobile) {
          this.submitMobile.disabled = true;
          this.submitMobile.textContent = 'Adding…';
        }
        this.setAttribute('aria-busy', 'true');
        this.errorEl.hidden = true;
        var self = this;
        fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || 'Could not add box'); }); } return r.json(); })
          .then(function () { window.location.href = self.dataset.cartUrl; })
          .catch(function (err) {
            self.submitting = false;
            self.removeAttribute('aria-busy');
            self.errorEl.textContent = err.message;
            self.errorEl.hidden = false;
            self.submitBtn.textContent = 'Add box to cart';
            if (self.submitMobile) self.submitMobile.textContent = 'Add box';
            self.render();
          });
      }
    }
    customElements.define('lb-box-builder', LbBoxBuilder);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { boxStatus: boxStatus, boxTotals: boxTotals, buildCartItems: buildCartItems, formatMoney: formatMoney };
  }
})();
